import type { State, Store } from '../../../types';

export const setupFetchSiteWhenUserFetched = (store: Store): void => {
  const searchParams = new URLSearchParams(window.location.search);

  // Prevent site fetch when watching a public recording
  const token = searchParams.get('token');
  if (token) return;

  let unsubscribe: ReturnType<typeof store.subscribe> | null = null;
  unsubscribe = store.subscribe(
    (state: State) => {
      if (!state.user) return;

      state.fetchSiteForUserId(state.user.user_id);
      unsubscribe?.();
    },
    (state: State) => state,
    (state: State, newState: State) => state.user === newState.user,
  );
};
